module.exports = __webpack_public_path__ + "static/img/A.O.史密斯「瀞」油烟机.39860ce0.png";